// removed by extract-text-webpack-plugin
module.exports = {"primaryColor":"#509119","secondaryColor":"#0E62AA","backButtonColor":"#DCDCDC"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/element_variables.scss
// module id = yv97
// module chunks = 0